import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/app/Header";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

const Resources = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/resources").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg)" }}>
      <Header />
      <main className="max-w-5xl mx-auto px-6 md:px-10 py-12">
        <button
          onClick={() => navigate("/dashboard")}
          className="inline-flex items-center gap-1 text-sm mb-6"
          style={{ color: "var(--ink-soft)" }}
          data-testid="resources-back-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <p className="text-xs uppercase tracking-[0.25em] mb-3" style={{ color: "var(--muted)" }}>
          When you need real help
        </p>
        <h1 className="font-serif text-4xl md:text-5xl mb-3" style={{ color: "var(--ink)" }}>
          Resources.
        </h1>
        <p className="mb-10 max-w-2xl" style={{ color: "var(--ink-soft)" }}>
          A small, hand-picked directory. If you are in crisis, please reach out to one of these
          first.
        </p>
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((r, i) => (
            <a
              key={i}
              href={r.url}
              target="_blank"
              rel="noreferrer"
              className="rounded-2xl border p-6 bg-white transition-all hover:-translate-y-0.5 hover:shadow-sm"
              style={{ borderColor: "var(--border)" }}
              data-testid={`page-resource-${i}`}
            >
              <p className="text-xs uppercase tracking-[0.18em] mb-2" style={{ color: "var(--muted)" }}>
                {r.category}
              </p>
              <h3 className="font-serif text-2xl mb-1" style={{ color: "var(--ink)" }}>
                {r.name}
              </h3>
              <p className="text-sm mb-2" style={{ color: "var(--ink-soft)" }}>
                {r.desc}
              </p>
              {r.phone && (
                <p className="text-sm" style={{ color: "var(--terracotta)" }}>
                  Call {r.phone}
                </p>
              )}
            </a>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Resources;
